<template>
  <div class="gallery">
    <div class="wrapper" v-for="(item, index) in images">
      <img :src="item.thumbUrl||item.imageUrl" @click="setActive(index)">
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      images: Array
    },
    methods: {
      setActive (idx) {
        this.$emit('changeIndex', idx)
      }
    }
  }
</script>

<style lang="stylus" src="./gallery.global.styl"/>

<style lang="stylus" src="./gallery.styl" scoped/>



// WEBPACK FOOTER //
// gallery.vue?4a776372